import { NgModule } from '@angular/core';
import { DurationPipe } from './duration.pipe';
import { EventTypeIconPipe } from './event-type-icon.pipe';
import { InvoiceUrlPipe } from './invoice-url.pipe';
import { MomentTimezonePipe } from './moment-timezone.pipe';
import { PatientUrlPipe } from './patient-url.pipe';
import { TagTextColourPipe } from './tag-text-colour.pipe';
import { TimeDisplayPipe } from './time-display.pipe';
import { TimingDisplayPipe } from './timing-display.pipe';

@NgModule({
  imports: [TimeDisplayPipe, TimingDisplayPipe, TagTextColourPipe],
  declarations: [
    InvoiceUrlPipe,
    PatientUrlPipe,
    EventTypeIconPipe,
    DurationPipe,
    MomentTimezonePipe,
  ],
  exports: [
    TagTextColourPipe,
    TimeDisplayPipe,
    InvoiceUrlPipe,
    PatientUrlPipe,
    EventTypeIconPipe,
    DurationPipe,
    MomentTimezonePipe,
    TimingDisplayPipe,
  ],
})
export class PipesModule {}
